import { useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const active = languages.find((l) => l.code === i18n.language) ?? languages[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-full border border-background-300/60 bg-background-50 px-3 py-1.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-global-line text-base" aria-hidden="true"></i>
        </span>
        <span className="whitespace-nowrap">{active.label}</span>
        <span className="w-3 h-3 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-xs" aria-hidden="true"></i>
        </span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} aria-hidden="true"></div>
          <div
            className="absolute right-0 z-20 mt-2 w-24 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1"
            role="listbox"
          >
            {languages.map((l) => (
              <button
                key={l.code}
                type="button"
                role="option"
                aria-selected={l.code === active.code}
                onClick={() => {
                  i18n.changeLanguage(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm transition-colors hover:bg-background-100 ${
                  l.code === active.code ? "font-bold text-primary-700" : "text-foreground-700"
                }`}
              >
                <span className="whitespace-nowrap">{l.label}</span>
                {l.code === active.code && (
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-check-line text-sm" aria-hidden="true"></i>
                  </span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}